import filterFirstPhone from 'common/filters/filterFirstPhone'

/**
 * Телефон клиники для записи: `lpuphone` либо первый номер адреса.
 */
export default function getLpuPhone({
  lpu,
  lpuAddress,
}: {
  lpu: {
    is_appointment_with_phone_enabled?: boolean
    lpuphone?: {
      phone?: string
    }
    lputype: {
      is_private: boolean
    }
    paid?: boolean
  }
  lpuAddress?: {
    phone?: string
  }
}): string | undefined {
  if (!lpu.is_appointment_with_phone_enabled && lpuAddress?.phone && !lpu.lputype.is_private && !lpu.paid) {
    return filterFirstPhone(lpuAddress.phone)
  }

  if (lpu.is_appointment_with_phone_enabled) {
    return lpu.lpuphone?.phone
  }

  return ''
}
